<template>
    <div class="contenedor_contenido">
        <div class="cabecera_contenido">

        </div>

        <div class="contenido_">
            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Anular Facturas
                        </h3>
                    </div>
                    <div class="col-sm-3 mt-3">
                        <label for="" class="form-label">Sucursal</label>
                        <select class="form-control form-control-sm" id="filtro_sucursal" v-model="sucursal">
                            <option value="">Seleccionar</option>
                            <option v-for="(item, index) in sucursales" :key="index" :value="item.codigo">{{ item.nombre
                            }}</option>
                        </select>
                    </div>
                    <div class="col-sm-2 mt-3">
                        <label for="" class="form-label">Filtro</label>
                        <select class="form-control form-control-sm" v-model="filtro">
                            <option value="fecha">Fecha</option>
                            <option value="nit">NIT</option>
                        </select>
                    </div>
                    <div v-if="filtro == 'fecha'" class="col-sm-2 mt-3">
                        <label for="" class="form-label">Fecha Inicial</label>
                        <input type="date" class="form-control form-control-sm" v-model="fecha_inicial" />
                    </div>
                    <div v-if="filtro == 'fecha'" class="col-sm-2 mt-3">
                        <label for="" class="form-label">Fecha Final</label>
                        <input type="date" class="form-control form-control-sm" v-model="fecha_final" />
                    </div>

                    <div v-if="filtro == 'nit'" class="col-sm-4 mt-3">
                        <label for="" class="form-label">NIT</label>
                        <input type="text" id="campo_nit" class="form-control form-control-sm" v-model="nit" />
                    </div>

                    <div class="col-sm-3 mt-5">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="obtener_facturas">Buscar</button>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <div class="marco_facturas_para_anular">

                            <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                                <thead>
                                    <tr>
                                        <th style="text-align: center;width: 10%;">
                                            Fecha emisión
                                        </th>
                                        <th style="text-align: center;width: 10%;">
                                            NIT
                                        </th>
                                        <th style="width: 40%;">
                                            Nombre
                                        </th>
                                        <th style="text-align: center;width: 10%;">
                                            Serie
                                        </th>
                                        <th style="text-align: center;width: 10%;">
                                            Número
                                        </th>
                                        <th style="text-align: center;width: 10%;">
                                            Monto
                                        </th>
                                        <th style="text-align: center;width: 10%;">
                                            ...
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in registros" :key="index">
                                        <td style="text-align: center;">
                                            {{ item.fecha_movimiento }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.nit_cliente }}
                                        </td>
                                        <td>
                                            {{ item.nombre_cliente }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.sat_serie }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.sat_numero }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ item.total_movimiento.toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            <button type="button" style="font-size: 10px;" class="btn btn-sm btn-danger"
                                                @click="anular_factura(item)"><i class="fas fa-ban"></i>
                                                Anular</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </b-row>
            </b-container>
        </div>
        <!-- <Busqueda v-if="modulo == 'busqueda'" /> -->

    </div>
</template>

<script>
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';
    import { atexto, minix } from '../functions/alertas';

    export default {
        name: 'Anulaciones',
        computed: {
            ...mapState(['sucursales', 'id_empresa_seleccionada', 'datos_usuario'])
        },
        data() {
            return {
                sucursal: '',
                filtro: 'fecha',
                fecha_inicial: moment(Date.now()).format('YYYY-MM-DD'),
                fecha_final: moment(Date.now()).format('YYYY-MM-DD'),
                nit: '',
                registros: []
            }
        },
        methods: {
            anular_factura(factura) {
                atexto({
                    titulo: 'Ambiente de pruebas',
                    cuerpo: 'No se puede anular facturas en ambiente de pruebas',
                    icono: 'warning'
                })
            },
            async obtener_facturas() {

                if (this.filtro == 'fecha') {

                    if (this.sucursal == '') {

                        minix({ icon: 'error', mensaje: 'Seleccione una sucursal', tiempo: 3000 })
                        document.getElementById('filtro_sucursal').focus()

                    } else {

                        let f = {
                            api: `movimientos-cabeceras/c/obtener-facturas-para-anular?empresa=${this.id_empresa_seleccionada}&sucursal=${this.sucursal}&fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&nit=${this.nit}&filtro=${this.filtro}`
                        }

                        let r = await this.obtener_data(f)

                        if (r.length == 0) {
                            minix({ icon: 'info', mensaje: 'No se encontraron registros en este rango de fechas', tiempo: 3000 })
                        } else {

                            this.registros = r
                        }

                    }
                } else {
                    if (this.nit.trim() == '') {

                        minix({ icon: 'error', mensaje: 'Ingrese un NIT', tiempo: 3000 })
                        document.getElementById('campo_nit').focus()

                    } else {
                        let f = {
                            api: `movimientos-cabeceras/c/obtener-facturas-para-anular?empresa=${this.id_empresa_seleccionada}&sucursal=${this.sucursal}&fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&nit=${this.nit}&filtro=${this.filtro}`
                        }

                        let r = await this.obtener_data(f)

                        if (r.length == 0) {
                            minix({ icon: 'info', mensaje: 'No se encontraron registros con este NIT', tiempo: 3000 })
                            document.getElementById('campo_nit').focus()
                        } else {
                            this.registros = r
                        }

                    }
                }



            },
            ...mapActions(['obtener_data'])
        },
    }
</script>

<style>
    .marco_facturas_para_anular {
        width: 100%;
        height: calc(100vh - 220px);
        overflow: auto;
    }
</style>